import { Box } from "@mui/material";
import ConnectWallet from "../../components/auth/signup/connect-wallet";
function ConnectWalletPage() {
  return <Box>{<ConnectWallet />}</Box>;
}

export default ConnectWalletPage;
